import { render, staticRenderFns } from "./IconSBP.vue?vue&type=template&id=8390b4d2&scoped=true&"
import script from "./IconSBP.vue?vue&type=script&lang=js&"
export * from "./IconSBP.vue?vue&type=script&lang=js&"
import style0 from "./IconSBP.vue?vue&type=style&index=0&id=8390b4d2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8390b4d2",
  null
  
)

export default component.exports